// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__88MvB","box":"styles_box__MSKk7","icon":"styles_icon__XgzDR"};